import type { Address } from 'src/components/checkout/steps/shipping/types'
import type { AddressData } from 'src/sdk/checkout/data/types/orderformAPI'
import { checkHyphenInCEP } from 'src/components/checkout/steps/shipping/hook/useAddressCheckout'
import { isPersistablePostalCode } from 'src/components/checkout/steps/utils'

import { resolveAddressReferenceLabel } from './addressReferenceLabel'

function addressDataToContextAddress(data: AddressData): Address {
  return {
    country: data.country ?? 'BRA',
    street: data.street ?? '',
    city: data.city ?? '',
    state: data.state ?? '',
    postalCode: data.postalCode ?? '',
    neighborhood: data.neighborhood ?? '',
    complement: data.complement ?? '',
    number: data.number ?? '',
    reference: resolveAddressReferenceLabel(data),
    receiverName: data.receiverName ?? '',
    addressId: data.addressId ?? '',
    addressType: data.addressType ?? 'residential',
  }
}

/** Keeps header CEP context and checkout address state aligned with a saved address selection. */
export function syncContextAddressFromAddressData(
  data: AddressData,
  setAddress: (address: Address) => void,
  setPostalCode: (postalCode: string) => void
) {
  setAddress(addressDataToContextAddress(data))

  if (isPersistablePostalCode(data.postalCode)) {
    setPostalCode(checkHyphenInCEP(data.postalCode ?? ''))

    return
  }

  setPostalCode('')
}
